import { ConditionSettingsKey } from 'cadenza/workbook/model/condition-settings-key';

const toPersistenceKey = ConditionSettingsKey.toPersistenceKey;

/**
 * @deprecated Use {@link import('cadenza/workbook/model/condition-settings-key').ConditionSettingsKey#toPersistenceKey} instead.
 */
export const CONDITION_SETTINGS = {
  CONDITION_MANDATORY: toPersistenceKey('CONDITION_MANDATORY'),
  CONDITION_ANIMATION_ALLOW: toPersistenceKey('CONDITION_ANIMATION_ALLOW'),
  CONDITION_ANIMATION_NUMBER_OF_FRAMES: toPersistenceKey('CONDITION_ANIMATION_NUMBER_OF_FRAMES'),
  CONDITION_CONTEXT_SENSITIVE: toPersistenceKey('CONDITION_CONTEXT_SENSITIVE'),
  CONDITION_MODE: toPersistenceKey('CONDITION_MODE'),
  TABLE_CONDITION_EXCLUDE_VALUES: toPersistenceKey('TABLE_CONDITION_EXCLUDE_VALUES'),
  TABLE_CONDITION_ALLOW_EXCLUDE_VALUES: toPersistenceKey('TABLE_CONDITION_ALLOW_EXCLUDE_VALUES'),
  TABLE_CONDITION_LIMIT: toPersistenceKey('TABLE_CONDITION_LIMIT'),
  LIKE_CONDITION_FILTER_TYPE: toPersistenceKey('LIKE_CONDITION_FILTER_TYPE'),
  LIKE_CONDITION_CASE_SENSITIVITY: toPersistenceKey('LIKE_CONDITION_CASE_SENSITIVITY'),
  LIKE_CONDITION_COMBINATION_TYPE: toPersistenceKey('LIKE_CONDITION_COMBINATION_TYPE'),
  VALUE_INTERVAL_CONDITION_LOWER_BOUNDARY_TYPE: toPersistenceKey('VALUE_INTERVAL_CONDITION_LOWER_BOUNDARY_TYPE'),
  VALUE_INTERVAL_CONDITION_UPPER_BOUNDARY_TYPE: toPersistenceKey('VALUE_INTERVAL_CONDITION_UPPER_BOUNDARY_TYPE'),
  DATE_CONDITION_INTERVAL: toPersistenceKey('DATE_CONDITION_INTERVAL'),
  DATE_CONDITION_INTERVAL_UNIT: toPersistenceKey('DATE_CONDITION_INTERVAL_UNIT'),
  DATE_CONDITION_INTERVAL_LENGTH: toPersistenceKey('DATE_CONDITION_INTERVAL_LENGTH'),
  DATE_CONDITION_INTERVAL_OVERLAP_LENGTH: toPersistenceKey('DATE_CONDITION_INTERVAL_OVERLAP_LENGTH'),
  DATE_CONDITION_DATA_INPUT_FILTER_MODE_ENABLED: toPersistenceKey('DATE_CONDITION_DATA_INPUT_FILTER_MODE_ENABLED'),
  DATE_CONDITION_STEPS_FILTER_MODE_ENABLED: toPersistenceKey('DATE_CONDITION_STEPS_FILTER_MODE_ENABLED'),
  DATE_CONDITION_ACTIVE_FILTER_MODE: toPersistenceKey('DATE_CONDITION_ACTIVE_FILTER_MODE'),
  DATE_CONDITION_FORMAT: toPersistenceKey('DATE_CONDITION_FORMAT'),
  SPATIAL_CONDITION_RELATION: toPersistenceKey('SPATIAL_CONDITION_RELATION')
} as const satisfies Partial<Record<ConditionSettingsKey, string>>;
